import { createGlobalState, useStorage } from '@vueuse/core';

export const useMessageHubDrafts = createGlobalState(() => {
    const drafts = useStorage('voxie-message-drafts', {}, sessionStorage);

    const generateDraftKey = ({ teamId, groupId, orgUnitId }, contactId) => {
        return `${teamId}_ou${orgUnitId || ''}_g${groupId || ''}_${contactId}`;
    };

    const getDraft = (context, contactId) => {
        const key = generateDraftKey(context, contactId);
        return drafts.value[key];
    };

    const saveDraft = (context, contactId, draftData) => {
        const key = generateDraftKey(context, contactId);

        const draft = {
            body: draftData.body || '',
            media_url: draftData.media_url || null,
            media_content_type: draftData.media_content_type || null,
            from_group_id: draftData.from_group_id || null,
            from_group_name: draftData.from_group_name || null,
        };

        if (draft.body?.trim() || draft.media_url) {
            drafts.value[key] = draft;
        } else {
            delete drafts.value[key];
        }
    };

    const clearDraft = (context, contactId) => {
        const key = generateDraftKey(context, contactId);
        delete drafts.value[key];
    };

    return {
        getDraft,
        saveDraft,
        clearDraft,
    };
});
